/* React */
import React from "react";

/* React Redux */
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/redux/store";
import { setDevOptions } from "src/redux/features/settings/settingsSlice";

/* Ionic */
import { IonToggle } from "@ionic/react";

/* Stylesheet */
import styles from "./DevModeToggle.module.scss";

const DevModeToggle: React.FC = () => {
  const dispatch = useDispatch();

  const settingsState = useSelector(
    (state: RootState) => state.settings
  );

  const { devOptions } = settingsState;

  return (
    <div className={styles.dev_mode_toggle}>
      <div>
        Enable <span>Dev Mode</span>
      </div>
      <IonToggle
        className={styles.toggle}
        checked={devOptions.isDevMode}
        onIonChange={(e) => {
          dispatch(
            setDevOptions({
              ...devOptions,
              isDevMode: e.detail.checked,
            })
          );
        }}
      />
    </div>
  );
};

export default DevModeToggle;
